import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon, DollarSignIcon } from 'lucide-react';
export function OpportunitySection() {
  return <section className="w-full bg-gradient-to-b from-slate-800 to-slate-900 py-20 px-4" data-id="element-99">
      <div className="max-w-5xl mx-auto" data-id="element-100">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-101">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold mb-6" data-id="element-102">
            El <span className="text-teal-400" data-id="element-103">vacío legal</span> de las PYMES
            en LATAM
          </h2>
          <p className="text-2xl md:text-3xl text-gold-400 font-semibold" data-id="element-104">
            Por qué te pagarán $300 USD por algo que te toma 15 minutos
          </p>
        </motion.div>

        <motion.div className="bg-slate-700 border-2 border-gold-400/50 rounded-xl p-8 md:p-12 mb-12" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-105">
          <div className="flex items-center gap-4 mb-6" data-id="element-106">
            <TrendingUpIcon className="w-12 h-12 text-gold-400" data-id="element-107" />
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-gold-400" data-id="element-108">
              El Arbitraje de Conocimiento
            </h3>
          </div>
          <p className="text-xl text-gray-200 leading-relaxed mb-6" data-id="element-109">
            Las PYMES en México, Colombia, Argentina y toda LATAM están{' '}
            <span className="text-red-400 font-semibold" data-id="element-110">
              perdiendo clientes a gritos
            </span>
            . No necesitan una "estrategia de IA transformacional". Necesitan
            que alguien les arregle el WhatsApp, les automatice las citas o les
            cree contenido que no dé pena.
          </p>
          <p className="text-xl text-gray-200 leading-relaxed" data-id="element-111">
            Mientras ellos ven la IA como "ciencia ficción", tú la verás como{' '}
            <span className="text-gold-400 font-semibold" data-id="element-112">
              tu herramienta de trabajo diaria
            </span>
            .
          </p>
        </motion.div>

        <motion.div className="bg-gradient-to-br from-teal-900/40 to-gold-900/40 border-2 border-teal-400/50 rounded-xl p-8 md:p-12" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-113">
          <div className="flex items-center gap-4 mb-6" data-id="element-114">
            <DollarSignIcon className="w-12 h-12 text-teal-400" data-id="element-115" />
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-teal-400" data-id="element-116">
              Inflación vs. IA
            </h3>
          </div>
          <p className="text-xl text-gray-200 leading-relaxed mb-6" data-id="element-117">
            La guía para{' '}
            <span className="text-gold-400 font-semibold" data-id="element-118">
              ganar en dólares
            </span>{' '}
            mientras tu moneda local se derrite.
          </p>
          <ul className="space-y-4 text-lg text-gray-200" data-id="element-119">
            <li className="flex items-start gap-3" data-id="element-120">
              <span className="text-gold-400 mt-1 font-bold" data-id="element-121">→</span>
              <span data-id="element-122">
                Cobra en USD, gasta en tu moneda local = poder adquisitivo
                multiplicado
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-123">
              <span className="text-gold-400 mt-1 font-bold" data-id="element-124">→</span>
              <span data-id="element-125">Trabaja desde casa, sin jefe, sin horarios fijos</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-126">
              <span className="text-gold-400 mt-1 font-bold" data-id="element-127">→</span>
              <span data-id="element-128">
                Construye activos digitales que generan ingresos mientras
                duermes
              </span>
            </li>
          </ul>
        </motion.div>
      </div>
    </section>;
}